import AnyCoinsPage from "./AnyCoinsPage.page";

export default AnyCoinsPage;
